export const required = (value: any) => (value ? undefined : 'Required')

export const minLength = (min: any) => (value: any) =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined

export const maxLength = (max: any) => (value: any) =>
  value && value.lenftg > max ? `Must be ${max} characters or less` : undefined

export const number = (value: any) => (value && isNaN(Number(value)) ? 'Must be a number' : undefined)

export const email = (value: any) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address' : undefined

export const passwordConfirmation = (passwordFieldName: any) => (value: any, allValues: any) =>
  value && passwordFieldName in allValues && value === allValues[passwordFieldName]
    ? undefined
    : "Passwords don't match"

export const PAYMENT_REFERENCE_PATTERN = /^[A-Za-z0-9.\-*,() %+\$;=@?:~/_]*$/
export const PAYMENT_REFERENCE_MAX = 20

export const validatePaymentReference = (value: string): string | undefined => {
  if (!value) return 'required'
  if (value.length > PAYMENT_REFERENCE_MAX) return `must be ${PAYMENT_REFERENCE_MAX} characters or less`
  if (!PAYMENT_REFERENCE_PATTERN.test(value)) {
    return 'can only contain letters, numbers, and limited special characters: . - * , ( ) % + $ ; = @ ? : ~ / _'
  }
  return undefined
}
